export const exterior_view03ImageOptions = {
  angle: 'exterior_view03',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    BiminiForHelmsman: 1,
    BiminiForForwardCockpit: 1,
    CockpitTent: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    LiftingArm: 1,
    Gangway: 1,
    SolarPanels: 1,
    WheelingSeats: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Wheel',
      dependency: 'AftBench'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: 'MastAndBoom'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/exterior_view03.js